import React from 'react'
import { IonPage, IonHeader, IonToolbar, IonTitle, IonContent, IonCard, IonCardContent, IonCardHeader, IonCardTitle, IonCardSubtitle} from '@ionic/react'


// z  Z

// 16 gold , 8 bronzse , 10 silver
const Achievements:React.FC = () => {
    return (
        <IonPage>
            <IonHeader>
                <IonToolbar>
                    <IonTitle>
                        Achievements
                    </IonTitle>
                </IonToolbar>
            </IonHeader>
            <IonContent>
                <IonCard style={{display:'block'}}>
                    <IonCardContent>
                        <IonCard>
                            <IonCardHeader style={{textAlign:'center'}}>
                                <IonCardTitle>
                                    CBSE ZONAL
                                </IonCardTitle>
                            </IonCardHeader>
                                    <IonCardHeader>
                                        <IonCardSubtitle style={{textAlign:'center'}}>
                                            CBSE Far East Zone
                                        </IonCardSubtitle>
                                        <IonCardContent style={{textAlign:'center'}}>
                                            <IonCardSubtitle> <b>Year :- 2018</b> </IonCardSubtitle>
                                            <IonCardSubtitle>Venue :- Krishna Public School</IonCardSubtitle>
                                            <IonCardSubtitle>10 Gold ,3 Silver ,2 Bronze</IonCardSubtitle>
                                        </IonCardContent>
                                        <IonCardContent style={{textAlign:'center'}}>
                                            <IonCardSubtitle> <b>Year :- 2019</b> </IonCardSubtitle>
                                            <IonCardSubtitle>Venue:- KrishnaPublicSchool,Raipur</IonCardSubtitle>
                                            <IonCardSubtitle>10 Gold ,5 Silver ,2 Bronze</IonCardSubtitle>
                                        </IonCardContent>
                                    </IonCardHeader>

                        </IonCard>
                        <IonCard>
                            <IonCardHeader>

                                <IonCardTitle style={{textAlign:'center'}}>CBSE Nationals</IonCardTitle>
                                <IonCardContent style={{ textAlign: 'center' }}>
                                    <IonCardSubtitle><b>Year :- 2018</b></IonCardSubtitle>
                                    <IonCardSubtitle>Venue :- Krishna Public School</IonCardSubtitle>
                                    <IonCardSubtitle>1 Gold ,3 Silver</IonCardSubtitle>
                                </IonCardContent>
                                <IonCardContent style={{ textAlign: 'center' }}>
                                    <IonCardSubtitle><b>Year :- 2019</b></IonCardSubtitle>
                                    <IonCardSubtitle>Venue :-Shri Shankarling Model School ,Chikalgud, Belgaum </IonCardSubtitle>
                                    <IonCardSubtitle>1 Silver , 1 Bronze</IonCardSubtitle>
                                </IonCardContent>
                            </IonCardHeader>
                        </IonCard>
                        <IonCard >
                            <IonCardHeader style={{ textAlign: 'center' }}>
                                <IonCardTitle >
                                    RSFI Nationals
                                </IonCardTitle>
                            </IonCardHeader>
                                <IonCardContent style={{textAlign:'center'}}>
                                    <IonCardSubtitle><b>Year :- 2019</b></IonCardSubtitle>
                                    <IonCardSubtitle>Venue :- Vishakhapatnam</IonCardSubtitle>
                                    <IonCardSubtitle>2 Silver</IonCardSubtitle>
                                </IonCardContent>
                                <IonCardContent style={{textAlign:'center'}}>
                                    <IonCardSubtitle><b>Year :- 2018</b></IonCardSubtitle>
                                    <IonCardSubtitle>Venue :- Vishakhapatnam</IonCardSubtitle>
                                    <IonCardSubtitle>4th and 5th Positions</IonCardSubtitle>
                                </IonCardContent>
                                <IonCardContent style={{textAlign:'center'}}>
                                <IonCardSubtitle><b>All India Speed Roller Skating Championship</b></IonCardSubtitle>
                                <IonCardSubtitle>Venue :- Greater Noida</IonCardSubtitle>
                                <IonCardSubtitle>3 Gold,2 Silver , 1Bronze</IonCardSubtitle>
                                </IonCardContent>
                                <IonCardContent style={{textAlign:'center'}}>
                                <IonCardSubtitle><b>1st National Ranking Speed Roller Skating Championship</b></IonCardSubtitle>
                                <IonCardSubtitle>Venue:- Greater Noida</IonCardSubtitle>
                                <IonCardSubtitle>2 Gold , 2 Silver</IonCardSubtitle>
                                </IonCardContent>

                        </IonCard>
                        <IonCard>
                            <IonCardHeader style={{ textAlign: 'center' }}>
                                <IonCardTitle>
                                    RSFI State
                                </IonCardTitle>
                            </IonCardHeader>
                            <IonCardContent style={{ textAlign: 'center' }}>
                                <IonCardSubtitle><b>Year :- 2018</b></IonCardSubtitle>
                                <IonCardSubtitle>Venue :- Sports Authority of India </IonCardSubtitle>
                                <IonCardSubtitle>26 Gold,13 Silver, 8 Bronze</IonCardSubtitle>
                            </IonCardContent>
                            <IonCardContent style={{textAlign:'center'}}>
                                <IonCardSubtitle><b>Year :- 2019</b></IonCardSubtitle>
                                <IonCardSubtitle>Venue :- Sports Authority of India </IonCardSubtitle>
                                <IonCardSubtitle>16 Gold , 8 Bronze , 10 Silver</IonCardSubtitle>
                            </IonCardContent>
                        </IonCard>
                    </IonCardContent>
                </IonCard>
            </IonContent>
        </IonPage>
    )
}

export default Achievements
